import React from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import Loader from "components/Loader";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// local
import EventContainer from "./EventContainer";
import Filters from "./Filters";

// redux
import { useSelector, useDispatch } from "react-redux";
import * as actions from "redux/actions/event";
import * as actionTypes from "redux/constants";

const Event = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const event = useSelector((state) => state.event);
  const auth = useSelector((state) => state.auth);

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [event.pagination.page]);

  React.useEffect(() => {
    dispatch(actions.getEvents(event.pagination.page, event.pagination.pageSize));

    return () => {
      dispatch(actions.resetEventsPagination());
    }
  }, [dispatch]);

  const handlePagination = (page) => {
    dispatch(actions.getEvents(page, event.pagination.pageSize));
  }

  const handleDelete = (id) => {
    const payload = { id };
    dispatch(actions.deleteEvent(payload));
  };

  const handleEdit = (data) => {
    navigate(`/upload/event/add-event`, { state: { editData: data } });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container>
        {event.loading ? (
          <Loader />
        ) : (
          <>
            {actionTypes.ADVANCED_SECTION.includes(auth.user?.role) && (
              <Grid item xs={12} md={12} xl={12}>
                <MDBox py={3} pl={1}>
                  <Filters />
                </MDBox>
              </Grid>
            )}
            <Grid item xs={12} md={12} xl={12}>
              <MDBox py={3} pr={1}>
                <EventContainer events={event.events} pagination={event.pagination} handlePagination={handlePagination} handleDelete={handleDelete} handleEdit={handleEdit} />
              </MDBox>
            </Grid>
          </>
        )}
      </Grid>
    </DashboardLayout>
  );
};

export default Event;
